const presetElements = [
  {
    type: 'datetime',
    element: 'el-date-picker',
    attributes: {
      type: 'datetime'
    }
  },
  {
    type: 'datetimerange',
    element: 'el-date-picker',
    attributes: {
      type: 'datetimerange'
    }
  }
]

export default presetElements
